import React, { Component } from 'react';
import { injectIntl, defineMessages } from 'react-intl';

import { Modal, ModalHeader, ModalBody, ModalFooter } from 'ui/common/modal';
import { connectModal as reduxModal } from 'redux-modal';

import Form, { FORM_NAME } from 'ui/users/skills/add/form';
import SubmitButton from 'ui/common/form/submit-button';

export const MODAL_NAME = 'add-user-skill';

const messages = defineMessages({
  title: {
    id: 'users.skills.add.modal.title',
    defaultMessage: 'Add a new skill',
  },
  subtitle: {
    id: 'users.skills.add.modal.subtitle',
    defaultMessage: 'We will help you validate them in order to boost your career.',
  },
  submit: {
    id: 'users.skills.add.modal.submit-button.label',
    defaultMessage: 'Submit',
  },
  cancel: {
    id: 'users.skills.add.modal.cancel-button.label',
    defaultMessage: 'Cancel',
  },
});

class AddUserSkillModal extends Component {
  render() {
    const { show, intl: { formatMessage }, handleHide } = this.props;

    return (
      <Modal isOpen={show} size="lg">
        <ModalHeader toggle={handleHide}>{formatMessage(messages.title)}</ModalHeader>
        <ModalBody>
          <Form modalName={MODAL_NAME} />
        </ModalBody>
        <ModalFooter>
          <div className="d-flex w-100 justify-content-between">
            <SubmitButton size="md" formName={FORM_NAME} explicitlyTriggerSubmit>
              {formatMessage(messages.submit)}
            </SubmitButton>
          </div>
        </ModalFooter>
      </Modal>
    );
  }
}

export default reduxModal({ name: MODAL_NAME })(injectIntl(AddUserSkillModal));
